// src/components/schedule/Schedule.js
import React, { useState } from 'react';
import Calendar from './Calendar';
import Activities from './Activities';
import FoodMenu from './FoodMenu';
import Holidays from './Holidays';
import { useLocation } from 'react-router-dom';

const Schedule = () => {
    const location = useLocation();

    const [scheduleView, setScheduleView] = useState(
        location.state?.activeTab || 'activities'
    );


    // Current date (selected by default)
    const today = new Date();

    // Get Monday of the current week
    const [currentWeekStart, setCurrentWeekStart] = useState(() => {
        const start = new Date(today);
        const day = start.getDay(); // Sunday = 0, Monday = 1, etc.
        const diff = day === 0 ? -6 : 1 - day; // shift to Monday
        start.setDate(start.getDate() + diff);
        return start;
    });

    const [selectedDate, setSelectedDate] = useState(today);

    return (
        <div className="pb-4">
            {/* Calendar */}
            <Calendar
                selectedDate={selectedDate}
                setSelectedDate={setSelectedDate}
                currentWeekStart={currentWeekStart}
                setCurrentWeekStart={setCurrentWeekStart}
            />

            {/* Schedule Tabs */}
            <div className="bg-white border-b sticky top-0 z-2">
                <div className="flex px-4 pt-4">
                    {[
                        { id: 'activities', label: 'Activities' },
                        { id: 'menu', label: 'Food Menu' },
                        { id: 'holidays', label: 'Holidays' }
                    ].map((view) => (
                        <button
                            key={view.id}
                            onClick={() => setScheduleView(view.id)}
                            className={`flex-1 pb-3 text-sm font-semibold transition ${scheduleView === view.id
                                ? 'text-cyan-500 border-b-2 border-cyan-500'
                                : 'text-gray-400'
                                }`}
                        >
                            {view.label}
                        </button>
                    ))}
                </div>
            </div>

            {/* Schedule Content */}
            <div className="p-4">
                {scheduleView === 'activities' && (
                    <Activities selectedDate={selectedDate} />
                )}
                {scheduleView === 'menu' && (
                    <FoodMenu selectedDate={selectedDate} />
                )}
                {scheduleView === 'holidays' && <Holidays />}
            </div>
        </div>
    );
};

export default Schedule;
